export enum BabyLatamMonitoring {
	VAGINAL_BLEEDING = 'meddiBabyLatamVaginalBleeding',
	TEMPERATURE = 'meddiBabyLatamTemperature',
	WEIGHT = 'meddiBabyLatamWeight',
	URINARY_TRACT_INFECTION = 'meddiBabyLatamUrinaryTractInfection',
	VAGINAL_INFECTION = 'meddiBabyLatamVaginalInfection',
	VOMITING = 'meddiBabyLatamVomiting',
	DIARRHOEA = 'meddiBabyLatamDiarrhoea',
	SWELLING = 'meddiBabyLatamSwelling',
	MEDICAMENTS = 'meddiBabyLatamMedicaments',
	BLOOD_PRESSURE = 'meddiBabyLatamBloodpresure',
	GLYCEMIA = 'meddiBabyLatamGlycemia',
	AMNIOTIC_FLUID_LEAK = 'meddiBabyLatamAmnioticFluidLeak',
	HYPERTENSION_SYMPTOMS = 'meddiBabyLatamHypertensionSymptoms',
	BREAST_SELF_ASSESSMENT = 'meddiBabyLatamBreastSelfAssessment',
	UTERINE_CONTRACTIONS = 'meddiBabyLatamUterineContractions',
	FETAL_MOVEMENTS = 'meddiBabyLatamFetalMovements',
	ROUTE_OF_DELIVERY = 'meddiBabyLatamRouteOfDelivery',
	COMBINED = 'meddibaby_grouped',
}
